import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgImageUpload(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7H6C5.44772 7 5 7.44772 5 8V16C5 16.5523 5.44772 17 6 17H16.2667H16.8H18C18.5523 17 19 16.5523 19 16V8C19 7.44771 18.5523 7 18 7ZM6 6H18C19.1046 6 20 6.89543 20 8V16C20 17.1046 19.1046 18 18 18H16.8H16.2667H6C4.89543 18 4 17.1046 4 16V8C4 6.89543 4.89543 6 6 6ZM17.416 9.72265C17.5692 9.95241 17.5071 10.2628 17.2774 10.416L12.2774 13.7494L11.9863 13.9434L11.7043 13.7365L10.1602 12.6042L7.26609 14.4233C7.03229 14.5703 6.72364 14.4999 6.57668 14.2661C6.42973 14.0323 6.50012 13.7236 6.73391 13.5767L9.91573 11.5767L10.2035 11.3958L10.4775 11.5968L12.0137 12.7233L16.7227 9.58397C16.9524 9.4308 17.2628 9.49289 17.416 9.72265ZM7 8C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10C7.55228 10 8 9.55228 8 9C8 8.44772 7.55228 8 7 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);

var ImageUploadOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ImageUploadOutline as default };
